module.exports = __webpack_public_path__ + "img/31.c07dba02.jpg";